import React from "react";
import { Field, Form } from "react-final-form";
import InputField from "../../General-UI/InputField";
import {
  MAX_NAME_LENGTH,
  PASSWORD_REGEX,
  PASSWORD_REQUIREMENT,
} from "../../../constants/constants";
import { useSelector } from "react-redux";
import {
  selectSignInError,
  selectTryingSignIn,
  setUser,
  signIn,
} from "slices/authSlice";

const validate = (formValues) => {
  const errors = {};

  if (!formValues.email) {
    errors.email = "You must enter an email";
  } else if (formValues.email.length > MAX_NAME_LENGTH) {
    errors.email =
      "Email too long (>" + MAX_NAME_LENGTH.toString() + " letters)";
  }
  if (!formValues.password) {
    errors.password = "You must enter a password";
  } else if (!formValues.password.match(PASSWORD_REGEX)) {
    errors.password = PASSWORD_REQUIREMENT;
  }

  return errors;
};

const SignInForm = ({ postSignIn }) => {
  const tryingSignIn = useSelector(selectTryingSignIn);
  const signInError = useSelector(selectSignInError);

  const onSubmit = (formValues) => {
    signIn(formValues.email, formValues.password).then((user) => {
      setUser(user)
        .then(postSignIn)
        .catch(() => {
          window.efs_debug &&
            window.log("SignInForm With Post. Could not set user from sign in");
        });
    });
  };

  return (
    <Form
      onSubmit={onSubmit}
      validate={validate}
      render={({ handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <div>
            <Field
              name="email"
              type="email"
              component={InputField}
              placeholder="Email address"
              className="input-box"
              liveCheck={false}
            />
          </div>
          <div>
            <Field
              name="password"
              component={InputField}
              type="password"
              placeholder="Password"
              className="input-box"
              liveCheck={false}
            />
          </div>
          <button
            onClick={handleSubmit}
            type="submit"
            className="confirm-button business-button"
            disabled={tryingSignIn}
          >
            {tryingSignIn ? "Logging In..." : "Log In"}
          </button>
          <div className="server-response-error">
            {signInError ? signInError.message : null}
          </div>
        </form>
      )}
    />
  );
};

export default SignInForm;
